import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Typography, Button } from "@mui/material";
import styled from "styled-components";


const ProceedBtn = styled(Button)`
    margin: 10px !important;
    padding: 10px 20px !important;
    background: #3150A1 !important;
    color: white !important;
    dispaly: flex;
    gap: 10px;
`;
const CancelBtn = styled(Button)`
    margin: 10px !important;
    padding: 10px 20px !important;
    background: none !important;
    color: #EB5757 !important;
`;

type propType = {
    open: boolean, setOpen: (value: any) => any,
    handleParentModalClose: () => void
}

const CancelContinueVerification = ({ open, setOpen, handleParentModalClose }: propType) => {
    const handleClose = () => {
        setOpen(false);
        handleParentModalClose();
    };

    const handleContinue = () => setOpen(false);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth={false}
            maxWidth="lg"
        >
            <DialogTitle sx={{ fontSize: "30px", minWidth: "400px", textAlign: "center", marginTop: "20px" }}>Cancel Visit?</DialogTitle>

            <DialogContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "20px" }}>
                <DialogContentText sx={{ fontSize: "20px", fontWeight: "400", textAlign: "center", padding: "0 20px" }}>
                    Cancel current visit verification?
                </DialogContentText>
            </DialogContent>

            <DialogActions sx={{ display: "flex", gap: "20px", justifyContent: "center", alignItems: "center", padding: "0 30px", marginBottom: "20px" }}>
                <CancelBtn onClick={handleClose}>
                    <Typography sx={{ textTransform: "capitalize", fontSize: "14px" }}>Cancel Verification</Typography>
                </CancelBtn>

                <ProceedBtn onClick={handleContinue}>
                    <Typography sx={{ textTransform: "capitalize", fontSize: "14px" }}>Continue Verification</Typography>
                </ProceedBtn>
            </DialogActions>

        </Dialog>
    )
}

export default CancelContinueVerification;